import dynamic from 'next/dynamic'

export const DynamicPromotionTermsModal = dynamic(
  () => import('.').then((mod) => mod.PromotionTermsModal),
  { ssr: false },
)
